import { API_URL } from "../api/BaseUrl";

export const VERIFICATION_URL = `${API_URL}/paystack/verify?reference=`;
export const PAYSTACK_CHARGE_AUTH_URL = `https://api.paystack.co/transaction/charge_authorization`;
export const PAYSTACK_PK_LIVE = `pk_live_48dd0c126b30e969b1b7eff9f27ded163647f4c6`;
export const PAYSTACK_PK_TEST = `pk_test_e1929473ff607af44d68b320871309eba86d377f`;

export const PAYSTACK_12500_PLAN = `PLN_5pu2q7dpbjvvgxj`;
